import { Mail } from 'lucide-react';

import { Button } from '@workspace/shadcn';

import { usePageMeta } from '../../lib/seo.tsx';
import { useModals } from '../components/modals.tsx';
import { Section } from '../components/section.tsx';
import { RetroGrid } from '../components/effects/retro-grid.tsx';

export default function Contact() {
  const { open } = useModals();

  usePageMeta({
    title: 'ITGL Academy | Contact Us',
    description:
      'Have questions about our courses or need more information? Reach out to our team for personalized assistance.',
    pathname: '/contact',
  });

  return (
    <Section className="mt-24 min-h-[60vh] overflow-hidden">
      <div className="relative z-10 mx-auto max-w-2xl text-center">
        <div className="bg-primary/10 mx-auto mb-6 w-fit rounded-full p-4">
          <Mail className="text-primary size-8" />
        </div>
        <h1 className="mb-4 text-4xl font-bold tracking-tighter">
          Get in Touch
        </h1>
        <p className="text-muted-foreground mb-8 text-lg">
          Have questions about our courses or need more information? We are here
          to help. Reach out to our team for personalized assistance and we will
          get back to you shortly.
        </p>
        <Button
          className="h-12 px-8 text-base text-white dark:text-black"
          onClick={() => open('contact')}
        >
          Send Us a Message
        </Button>
      </div>

      <div className="relative -top-10 -z-10 h-[360px] overflow-hidden">
        <RetroGrid className="-top-40" />
      </div>
    </Section>
  );
}
